(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["closing-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__stxPdpLoaded) return;
  window.__stxPdpLoaded = true;

  var root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function mainForm(root) {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) if (!root.contains(forms[i])) return forms[i];
    return null;
  }
  function currentId(root) {
    var f = mainForm(root), el = f && f.querySelector('[name="id"]');
    var v = el && el.value;
    if (!v) v = new URLSearchParams(window.location.search).get('variant');
    return v || '';
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    var variants = JSON.parse(root.querySelector('[data-variants]').textContent || '[]');
    var map = {}; variants.forEach(function (v) { map[v.id] = v; });
    var btn = root.querySelector('[data-stx-pdp-button]');
    var line = root.querySelector('[data-stx-pdp-line]');
    var status = root.querySelector('[data-stx-pdp-status]');
    var d = root.dataset, last = null, busy = false;

    function sync() {
      var v = map[currentId(root)];
      var key = v ? v.id + ':' + v.available : 'none';
      if (key === last || busy) return;
      last = key;
      line.textContent = d.lineTemplate.replace('[price]', v ? v.price : d.fromPrice);
      if (v && !v.available) { btn.disabled = true; btn.textContent = d.labelSoldout; }
      else { btn.disabled = false; btn.textContent = d.label; }
    }

    function scrollToBuyBox() {
      var target = null;
      try { target = document.querySelector(d.buybox); } catch (e) {}
      if (!target || root.contains(target)) target = mainForm(root);
      status.textContent = d.hint;
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.classList.add('stx-buybox-highlight');
      setTimeout(function () { target.classList.remove('stx-buybox-highlight'); }, 2200);
    }

    btn.addEventListener('click', function () {
      if (busy) return;
      var id = currentId(root), v = map[id];
      if (!v && d.single === 'true' && variants.length) v = variants[0];
      if (!v) { scrollToBuyBox(); return; }
      if (!v.available) return;

      var item = { id: Number(v.id), quantity: 1 };
      var f = mainForm(root), sp = f && f.querySelector('[name="selling_plan"]');
      if (sp && sp.value) item.selling_plan = Number(sp.value);

      busy = true; btn.disabled = true; btn.textContent = d.labelAdding; status.textContent = '';
      fetch(root_url + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) {
        return r.json().then(function (data) { if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart'); return data; });
      }).then(function () {
        if (d.after === 'redirect') { window.location.href = root_url + 'cart'; return; }
        status.innerHTML = '';
        status.appendChild(document.createTextNode(d.success + ' '));
        var a = document.createElement('a'); a.href = root_url + 'cart'; a.textContent = 'View cart'; status.appendChild(a);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        busy = false; last = null; sync();
      }).catch(function (err) {
        status.textContent = err.message;
        busy = false; last = null; sync();
      });
    });

    document.addEventListener('change', sync);
    sync();
    var timer = setInterval(function () {
      if (!document.body.contains(root)) { clearInterval(timer); return; }
      sync();
    }, 400);
  }

  function boot() { document.querySelectorAll('[data-stx-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
